import React, { useEffect, useRef } from 'react';

import { useChatBodyContext } from '../chat-body-context';
import { useWidgetContext } from 'widget/widget-context';
import * as Env from 'widget/env';

import ConvoContext from './convo-context';
import GuestForm from './guest-form/guest-form';
import Thread from './thread/thread';
import Typing from './typing/typing';

interface ConvoProps {
  createAccessToken: (guest?: Env.Guest) => Promise<string | null>;
  isTyping: boolean;
  messageList: Env.Message[];
  openWs: (accessToken: string) => Promise<unknown>;
}

const Convo = ({
  createAccessToken,
  isTyping,
  messageList,
  openWs,
}: ConvoProps) => {
  const { widget } = useWidgetContext();
  const { accessToken } = useChatBodyContext();

  const ref = useRef<HTMLDivElement>(null);

  const scrollToBottom = () => {
    if (!ref.current) return;

    const { scrollHeight, clientHeight, scrollTop } = ref.current;
    const scrollGap = scrollHeight - (clientHeight + scrollTop);
    if (scrollGap > clientHeight) return;

    ref.current.scrollTo({ top: scrollHeight, behavior: 'smooth' });
  };

  useEffect(() => {
    if (isTyping) scrollToBottom();
  }, [isTyping]);

  useEffect(() => {
    scrollToBottom();
  }, [messageList.length]);

  useEffect(() => {
    if (!ref.current) return;
    ref.current.scrollTop = ref.current.scrollHeight;
  }, []);

  return (
    <ConvoContext.Provider value={{ messageList }}>
      <div className="whatcrm-widget-convo" ref={ref}>
        <div className="whatcrm-widget-convo__wrapper">
          {messageList.map(message => (
            <Thread key={message.id} message={message} />
          ))}

          {isTyping && <Typing />}

          {accessToken === undefined && widget.is_register_form != false && (
            <GuestForm createAccessToken={createAccessToken} openWs={openWs} />
          )}
        </div>
      </div>
    </ConvoContext.Provider>
  );
};

export default Convo;
